import * as React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import theme from "theme";
// Fonts
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/ibm-plex-mono/400.css";
// Providers
import EmotionCacheProvider from "components/EmotionCacheProvider";
// Custom Routes
import ProtectedRoute from "components/ProtectedRoute";
// Layouts
import GuestLayout from "layouts/GuestLayout";
// Guest Pages
import Login from "pages/Login";
import ConfirmAccount from "pages/ConfirmAccount";
import ActivateAccount from "pages/ActivateAccount";
import SetPasswordAccount from "pages/SetPasswordAccount";
import ApprovalDetails from "pages/ApprovalDetail/ApprovalDetails";
import Audit from "pages/Audit";
import Forgot from "pages/Forgot";
import OAuth2 from "pages/OAuth2";
import UsersActivationPending from "pages/UsersActivationPending";

// Auth Pages
const Payment = React.lazy(() => import("pages/Payment"));
const ApprovalDashboard = React.lazy(() => import("pages/ApprovalDashboard"));
const CreateApprovalSuccess = React.lazy(
  () => import("pages/CreateApprovalSuccess")
);
const Users = React.lazy(() => import("pages/Users"));

const appGuestRoutes = [
  {
    path: "/",
    component: <Login />,
  },
  {
    path: "/set-password",
    component: <SetPasswordAccount />,
  },
  {
    path: "/forgot",
    component: <Forgot />,
  },
  {
    path: "/confirm-account",
    component: <ConfirmAccount />,
  },
  {
    path: "/auth/activate",
    component: <ActivateAccount />,
  },
  {
    path: "/auth/authorize",
    component: <OAuth2 />,
  },
  // {
  //   path: "/register",
  //   component: <Register />,
  // },
  // {
  //   path: "/register-success",
  //   component: <RegisterSuccess />,
  // },
];

const appProtectedRoutes = [
  {
    path: "/payments",
    component: <Payment />,
  },
  {
    path: "/payments/:paymentId",
    component: <ApprovalDetails />,
  },
  {
    path: "/payroll-success/:id",
    component: <CreateApprovalSuccess />,
  },
  {
    path: "/payment-processing-requests",
    component: <ApprovalDashboard />,
  },
  {
    path: "/payment-summary",
    component: <ApprovalDashboard />,
  },
  {
    path: "/approval-dashboard",
    component: <ApprovalDashboard />,
  },
  {
    path: "/audit-activity",
    component: <Audit />,
  },
  {
    path: "/enterprise-users",
    component: <Users />,
  },
  {
    path: "/activation-pending-enterprise-users",
    component: <UsersActivationPending />,
  },
  // {
  //   path: "/payments/:action",
  //   component: <PaymentAction />,
  // },
  // {
  //   path: "/payments/:action/:from",
  //   component: <PaymentAction />,
  // },
  // {
  //   path: "/enquiry/:action",
  //   component: <Enquiry />,
  // },
  // {
  //   path: "/accounts/:id",
  //   component: <Account />,
  // },
  // {
  //   path: "/contact",
  //   component: <Contact />,
  // },
  // {
  //   path: "/business-banking",
  //   component: <BusinessBanking />,
  // },
  // {
  //   path: "/business-banking/salary-payment",
  //   component: <SalaryPayment />,
  // },
  // {
  //   path: "/business-banking/foreign-exchange",
  //   component: <ForeignExchange />,
  // },
  // {
  //   path: "/profile",
  //   component: <Profile />,
  // },
  // {
  //   path: "/products-and-offers",
  //   component: <ProductsAndOffers />,
  // },
  // {
  //   path: "/submit-document",
  //   component: <DocumentCollection />,
  // },
  // {
  //   path: "/upload-payment-file",
  //   component: <UploadPaymentFile />,
  // },
  // {
  //   path: "/upload-proof-prefund",
  //   component: <UploadProofPrefund />,
  // },
];

export const App = () => (
  <EmotionCacheProvider>
    <ChakraProvider theme={theme}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Router>
            {appGuestRoutes.map((n) => (
              <Route key={n.path} exact path={n.path}>
                <GuestLayout>{n.component}</GuestLayout>
              </Route>
            ))}

            {appProtectedRoutes.map((n) => (
              <ProtectedRoute key={n.path} exact path={n.path}>
                {n.component}
              </ProtectedRoute>
            ))}
          </Router>
        </PersistGate>
      </Provider>
    </ChakraProvider>
  </EmotionCacheProvider>
);
